module.exports = __webpack_public_path__ + "static/media/iskrobezopasnye_promyshlennosti.15a36ffa.pdf";